import styled from 'styled-components';

const SliderInstagramStyle = styled.section`
	--distanceSwiperTop: var(--sp9x);
	--sliderIconsDistance: var(--sp2x);
	--sliderIconSize: var(--sp5x);
	--swiperSlideWidth: calc(25% - 1.5 * var(--colPadding));
	--sizeImageEvery1: 100%;
	--sizeImageEvery2: 147.8%;
	--sizeImageEvery3: 100%;
	--sizeImageEvery4: 132.5%;
	--borderRadiusImage: var(--sp3x);
	--buttonRight: var(--sp2x);
	--buttonBottom: var(--sp2x);
	--buttonInstTB: var(--sp1-5x);
	--buttonInstLR: var(--sp2x);
	--borderRadiusInst: var(--sp3x);

	.top-block {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.slider-icons-blok {
		display: flex;
		align-items: center;
		gap: var(--sliderIconsDistance);
	}

	.slider-icon {
		font-size: var(--sliderIconSize);
		will-change: transform;
		transition: transform var(--trTime) ease-out;
		cursor: pointer;
	}

	.slider-block {
		position: relative;

		margin-top: var(--distanceSwiperTop);
		.empty {
			position: absolute;
			width: var(--contPaddingLR);
			background-color: var(--neutral1000);
			height: 105%;
			z-index: 1000;
		}

		.left-empty {
			left: 0;
			transform: translate(-100%, -1%);
		}

		.right-empty {
			right: 0;
			top: 0;
			transform: translate(100%, -1%);
		}
	}

	.swiper {
		display: flex;
		height: 100%;
	}

	.swiper-wrapper {
		height: unset !important;
	}
	.swiper {
		overflow: visible !important;
	}
	.swiper-slide {
		width: var(--swiperSlideWidth);
		margin-right: var(--gutter);

		&:last-child {
			margin-right: 0 !important;
		}

		&:nth-child(1),
		&:nth-child(3) {
			transform: translateY(100%);
		}
		&:nth-child(2),
		&:nth-child(4) {
			transform: translateY(125%);
		}
	}

	.swiper-button-disabled {
		pointer-events: none;
		cursor: default;
		opacity: 0.5;
	}

	.swiper-wrapper {
		:nth-child(4n + 1) {
			.image-cont {
				--proportion: var(--sizeImageEvery1);
			}
		}
		:nth-child(4n + 2) {
			.image-cont {
				--proportion: var(--sizeImageEvery2);
			}
		}
		:nth-child(4n + 3) {
			.image-cont {
				--proportion: var(--sizeImageEvery3);
			}
		}
		:nth-child(4n + 4) {
			.image-cont {
				--proportion: var(--sizeImageEvery4);
			}
		}
	}

	.wrapper-image {
		overflow: hidden;
		border-radius: var(--borderRadiusImage);
		position: relative;
		transition: border-color var(--trTime) ease-out;

		.image-cont {
			overflow: hidden;
			border-radius: var(--borderRadiusImage);
		}
	}

	.instagram-button {
		position: absolute;
		z-index: 1;
		bottom: var(--buttonBottom);
		right: var(--buttonRight);
		border-radius: var(--borderRadiusInst);
		padding: var(--buttonInstTB) var(--buttonInstLR);
		color: var(--neutral1000);
		background-color: var(--mainColor);
		border: unset;
		transition: all var(--trTime) ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.slider-icon {
				&:hover {
					transform: scale(1.2);
				}
			}

			.wrapper-image {
				&:hover {
					.instagram-button {
						background-color: var(--pink1000);
						color: var(--mainColor);
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sliderIconSize: var(--sp4x);
		--distanceSwiperTop: var(--sp7x);
		--buttonInstTB: var(--sp1x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceSwiperTop: var(--sp6x);
		--sizeImageEvery2: 148.3%;
		--borderRadiusInst: var(--sp2-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceSwiperTop: var(--sp4x);
		--sizeImageEvery2: 151.4%;
		--sizeImageEvery4: 135%;
		--borderRadiusImage: var(--sp2-5x);
		--buttonRight: var(--sp1x);
		--buttonBottom: var(--sp1x);
		--borderRadiusInst: var(--sp2x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sliderIconSize: var(--sp3x);
		--buttonRight: var(--sp1-5x);
		--buttonBottom: var(--sp1-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sliderIconsDistance: var(--sp1-5x);
		--sizeImageEvery2: 149.6%;
		--sizeImageEvery4: 133.3%;
		--borderRadiusImage: var(--sp1-5x);
		--buttonRight: var(--sp1x);
		--buttonBottom: var(--sp1x);
		--buttonInstTB: var(--sp1x);
		--buttonInstLR: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceSwiperTop: var(--sp3x);
		--swiperSlideWidth: calc(50% - var(--colPadding));
		--sizeImageEvery2: 152.2%;
		--sizeImageEvery4: 133.3%;

		.top-block {
			flex-direction: column;
			align-items: flex-start;
			gap: var(--sp3x);
		}
	}
`;
export default SliderInstagramStyle;
